import { User, UserRole, UserStatus, ProfitRecord, DashboardStats, ElectricityData, CalculationResult, ProfitStatus } from '../types';

// 模拟用户数据
export const mockUsers: User[] = [
  {
    id: 1,
    openid: 'wx_001',
    nickname: '张三',
    avatarUrl: 'https://api.dicebear.com/7.x/avataaars/svg?seed=1',
    phone: '13800138001',
    role: 'admin',
    status: 'active',
    referralCode: 'ADMIN01',
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-12-20T00:00:00Z',
    promotionCount: 15,
    teamSize: 156
  },
  {
    id: 2,
    openid: 'wx_002',
    nickname: '李四',
    avatarUrl: 'https://api.dicebear.com/7.x/avataaars/svg?seed=2',
    phone: '13800138002',
    role: 'level3',
    status: 'active',
    parentId: 1,
    referralCode: 'L3A001',
    createdAt: '2024-01-15T00:00:00Z',
    updatedAt: '2024-12-20T00:00:00Z',
    promotionCount: 8,
    teamSize: 89
  },
  {
    id: 3,
    openid: 'wx_003',
    nickname: '王五',
    avatarUrl: 'https://api.dicebear.com/7.x/avataaars/svg?seed=3',
    phone: '13800138003',
    role: 'level3',
    status: 'active',
    parentId: 2,
    referralCode: 'L3B002',
    createdAt: '2024-02-01T00:00:00Z',
    updatedAt: '2024-12-20T00:00:00Z',
    promotionCount: 12,
    teamSize: 67
  },
  {
    id: 4,
    openid: 'wx_004',
    nickname: '赵六',
    avatarUrl: 'https://api.dicebear.com/7.x/avataaars/svg?seed=4',
    phone: '13800138004',
    role: 'level2',
    status: 'active',
    parentId: 3,
    referralCode: 'L2C003',
    createdAt: '2024-03-01T00:00:00Z',
    updatedAt: '2024-12-20T00:00:00Z',
    promotionCount: 25,
    teamSize: 45
  },
  {
    id: 5,
    openid: 'wx_005',
    nickname: '钱七',
    avatarUrl: 'https://api.dicebear.com/7.x/avataaars/svg?seed=5',
    phone: '13800138005',
    role: 'level1',
    status: 'active',
    parentId: 4,
    referralCode: 'L1D004',
    createdAt: '2024-04-01T00:00:00Z',
    updatedAt: '2024-12-20T00:00:00Z',
    promotionCount: 30,
    teamSize: 20
  },
  {
    id: 6,
    openid: 'wx_006',
    nickname: '孙八',
    avatarUrl: 'https://api.dicebear.com/7.x/avataaars/svg?seed=6',
    phone: '13800138006',
    role: 'retail',
    status: 'active',
    parentId: 5,
    referralCode: 'RTLE005',
    createdAt: '2024-05-01T00:00:00Z',
    updatedAt: '2024-12-20T00:00:00Z'
  }
];

// 模拟分润记录数据
export const mockProfitRecords: ProfitRecord[] = [
  {
    id: 1,
    userId: 1,
    type: 'management',
    periodType: 'monthly',
    periodStart: '2024-12-01',
    periodEnd: '2024-12-31',
    baseAmount: 1000000,
    rate: 0.01,
    profitAmount: 10000,
    bonusAmount: 2000,
    totalAmount: 12000,
    status: 'paid',
    createdAt: '2024-12-01T00:00:00Z',
    updatedAt: '2024-12-20T00:00:00Z'
  },
  {
    id: 2,
    userId: 2,
    type: 'regional',
    periodType: 'monthly',
    periodStart: '2024-12-01',
    periodEnd: '2024-12-31',
    baseAmount: 500000,
    rate: 0.015,
    profitAmount: 7500,
    totalAmount: 7500,
    status: 'paid',
    createdAt: '2024-12-01T00:00:00Z',
    updatedAt: '2024-12-20T00:00:00Z'
  },
  {
    id: 3,
    userId: 3,
    type: 'bonus',
    periodType: 'monthly',
    periodStart: '2024-12-01',
    periodEnd: '2024-12-31',
    baseAmount: 200000,
    rate: 0.01,
    profitAmount: 2000,
    bonusAmount: 500,
    totalAmount: 2500,
    status: 'confirmed',
    createdAt: '2024-12-01T00:00:00Z',
    updatedAt: '2024-12-20T00:00:00Z'
  },
  {
    id: 4,
    userId: 4,
    type: 'basic',
    periodType: 'monthly',
    periodStart: '2024-12-01',
    periodEnd: '2024-12-31',
    baseAmount: 150000,
    rate: 0.25,
    profitAmount: 37500,
    totalAmount: 37500,
    status: 'confirmed',
    createdAt: '2024-12-01T00:00:00Z',
    updatedAt: '2024-12-20T00:00:00Z'
  },
  {
    id: 5,
    userId: 5,
    type: 'basic',
    periodType: 'monthly',
    periodStart: '2024-12-01',
    periodEnd: '2024-12-31',
    baseAmount: 80000,
    rate: 0.45,
    profitAmount: 36000,
    bonusAmount: 1000,
    totalAmount: 37000,
    status: 'pending',
    createdAt: '2024-12-01T00:00:00Z',
    updatedAt: '2024-12-20T00:00:00Z'
  }
];

// 模拟用电数据
export const mockElectricityData: ElectricityData[] = [
  {
    id: 1,
    userId: 6,
    year: 2024,
    month: 12,
    usage: 100,
    retailPrice: 0.8,
    purchaseCost: 0.6,
    totalAmount: 80000,
    createdAt: '2024-12-01T00:00:00Z',
    updatedAt: '2024-12-20T00:00:00Z'
  },
  {
    id: 2,
    userId: 6,
    year: 2024,
    month: 11,
    usage: 95,
    retailPrice: 0.8,
    purchaseCost: 0.6,
    totalAmount: 76000,
    createdAt: '2024-11-01T00:00:00Z',
    updatedAt: '2024-11-30T00:00:00Z'
  },
  {
    id: 3,
    userId: 6,
    year: 2024,
    month: 10,
    usage: 105,
    retailPrice: 0.8,
    purchaseCost: 0.6,
    totalAmount: 84000,
    createdAt: '2024-10-01T00:00:00Z',
    updatedAt: '2024-10-31T00:00:00Z'
  }
];

// 模拟仪表板统计数据
export const mockDashboardStats: DashboardStats = {
  totalUsers: 156,
  activeUsers: 142,
  totalRevenue: 2400000,
  totalProfit: 480000,
  monthlyGrowth: 12.5,
  userGrowth: 8.3
};

// 模拟业绩计算结果
export const mockCalculationResult: CalculationResult = {
  totalRevenue: 80000,
  totalCost: 60000,
  basicProfit: 20000,
  distributableProfit: 18000,
  myEarnings: 8600,
  details: [
    {
      item: '零售电费',
      formula: '100万度 × 0.8元/度',
      amount: 80000
    },
    {
      item: '购电成本',
      formula: '100万度 × 0.6元/度',
      amount: 60000
    },
    {
      item: '基础毛利',
      formula: '零售电费 - 购电成本',
      amount: 20000
    },
    {
      item: '可分配毛利',
      formula: '基础毛利 × (1 - 10%平台抽成)',
      amount: 18000
    },
    {
      item: '基础分润',
      formula: '可分配毛利 × 45%分润比例',
      amount: 8100
    },
    {
      item: '新签单奖励',
      formula: '5个新用户 × 1000元/用户',
      amount: 500
    },
    {
      item: '总收益',
      formula: '基础分润 + 新签单奖励',
      amount: 8600
    }
  ]
};

// 角色映射
export const roleMap: Record<UserRole, string> = {
  admin: '管理员',
  level3: '三级推荐官',
      level2: '二级推荐官',
      level1: '一级推荐官',
      retail: '用电用户'};

// 状态映射
export const statusMap: Record<UserStatus, string> = {
  active: '活跃',
  inactive: '非活跃',
  suspended: '已暂停'
};

// 生成随机用户数据的函数
export const generateRandomUsers = (count: number): User[] => {
  const roles: UserRole[] = ['retail', 'level1', 'level2', 'level3'];
  const statuses: UserStatus[] = ['active', 'inactive'];
  const users: User[] = [];

  for (let i = 0; i < count; i++) {
    users.push({
      id: 100 + i,
      openid: `wx_${String(100 + i).padStart(6, '0')}`,
      nickname: `用户${i + 1}`,
      avatarUrl: `https://api.dicebear.com/7.x/avataaars/svg?seed=${100 + i}`,
      phone: `1380013${String(1000 + i).padStart(4, '0')}`,
      role: roles[Math.floor(Math.random() * roles.length)],
      status: statuses[Math.floor(Math.random() * statuses.length)],
      referralCode: generateReferralCode(),
      parentId: Math.random() > 0.3 ? Math.floor(Math.random() * 10) + 1 : undefined,
      createdAt: new Date(2024, Math.floor(Math.random() * 12), Math.floor(Math.random() * 28) + 1).toISOString(),
      updatedAt: new Date().toISOString(),
      promotionCount: Math.floor(Math.random() * 50),
      teamSize: Math.floor(Math.random() * 200)
    });
  }

  return users;
};

// 生成推荐码的辅助函数
function generateReferralCode(): string {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  let result = '';
  for (let i = 0; i < 6; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
}

// 生成分润记录数据的函数
export const generateRandomProfitRecords = (count: number): ProfitRecord[] => {
  const types: ProfitRecord['type'][] = ['basic', 'bonus', 'management', 'regional'];
  const statuses: ProfitStatus[] = ['pending', 'confirmed', 'paid'];
  const records: ProfitRecord[] = [];

  for (let i = 0; i < count; i++) {
    const baseAmount = Math.floor(Math.random() * 500000) + 10000;
    const rate = Math.random() * 0.5;
    const profitAmount = Math.floor(baseAmount * rate);

    records.push({
      id: 100 + i,
      userId: Math.floor(Math.random() * 50) + 1,
      type: types[Math.floor(Math.random() * types.length)],
      periodType: 'monthly',
      periodStart: '2024-12-01',
      periodEnd: '2024-12-31',
      baseAmount,
      rate: parseFloat(rate.toFixed(4)),
      profitAmount,
      bonusAmount: Math.random() > 0.5 ? Math.floor(Math.random() * 5000) : undefined,
      totalAmount: profitAmount + (Math.random() > 0.5 ? Math.floor(Math.random() * 5000) : 0),
      status: statuses[Math.floor(Math.random() * statuses.length)],
      createdAt: new Date(2024, 11, Math.floor(Math.random() * 28) + 1).toISOString(),
      updatedAt: new Date().toISOString()
    });
  }

  return records;
};
